import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance3htwskyquhuuo as Companion_getInstance } from '../models/ScreenTransitions.mjs';
import { get_overlayFrame1s8kw8rhusiwv as get_overlayFrame } from './l2/appBase.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  animateOut2lmw712yu1fdk as animateOut,
  animateInmud32j2tnt7g as animateIn,
} from './animations.js.mjs';
import { get_native16zxqjg6lrtlz as get_native } from './NativeElement.commonHtml.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from './Element.ext.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { pushDismissableDialog1yvcdbsxh0ht9 as pushDismissableDialog } from './ViewContextExtensions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ContainerElementjaaooy2agvhc as ContainerElement } from './Element.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function overlay(_this__u8e3s4, modal, navClosable, transition, body) {
  modal = modal === VOID ? true : modal;
  navClosable = navClosable === VOID ? modal : navClosable;
  transition = transition === VOID ? Companion_getInstance().Fade_1 : transition;
  // Inline function 'kotlin.with' call
  var $this$with = get_overlayFrame(_this__u8e3s4);
  var willRemove = {_v: null};
  var unregister = {_v: null};
  var close = () => {
    var tmp0_safe_receiver = willRemove._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var it = tmp0_safe_receiver;
      animateOut(it, transition.reverse_1, () => {
        $this$with.removeChild_kofmvd_k$(it);
        willRemove._v = null;
        return Unit_instance;
      });
      var tmp0_safe_receiver_0 = unregister._v;
      if (tmp0_safe_receiver_0 == null)
        null;
      else
        tmp0_safe_receiver_0();
      unregister._v = null;
    }
    return Unit_instance;
  };
  // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
  var tmp = get_native($this$with).element_1;
  var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var this_0 = tmp0_safe_receiver;
    var animate = get_animationsEnabled();
    try {
      if (animate) {
        set_animationsEnabled(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = this_0.__suppressMutationObserverClass;
        var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          // Inline function 'kotlin.js.asDynamic' call
          this_0.__suppressMutationObserverClass = n;
          tmp_2 = n;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var e = tmp_2;
        this_0.classList.add('notransition');
        var tmp1_elvis_lhs = this_0.getAttribute('class');
        e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
      if (navClosable) {
        unregister._v = pushDismissableDialog(_this__u8e3s4, close);
      }
      // Inline function 'com.lightningkite.kiteui.views.beforeSetupContainer' call
      body(new (overlay$1())(transition, $this$with, willRemove), close);
    }finally {
      if (animate) {
        var tmp_3 = window;
        tmp_3.setTimeout(() => {
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          var this_1 = this_0;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = this_1.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.js.asDynamic' call
            this_1.__suppressMutationObserverClass = n;
            tmp_0 = n;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var e = tmp_0;
          this_0.classList.remove('notransition');
          var tmp1_elvis_lhs = this_1.getAttribute('class');
          e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          return Unit_instance;
        }, 100);
        set_animationsEnabled(true);
      }
    }
    tmp_0 = Unit_instance;
  }
  if (tmp_0 == null) {
    if (navClosable) {
      unregister._v = pushDismissableDialog(_this__u8e3s4, close);
    }
    // Inline function 'com.lightningkite.kiteui.views.beforeSetupContainer' call
    body(new (overlay$2())(transition, $this$with, willRemove), close);
  }
}
var overlay$1Class;
function overlay$1() {
  if (overlay$1Class === VOID) {
    class $ {
      constructor($transition, $this, $willRemove) {
        this.$transition_1 = $transition;
        this.$this_1 = $this;
        this.$willRemove_1 = $willRemove;
        this.$$delegate_0__1 = $this;
      }
      willAddChild_hz2iwc_k$(element) {
        this.$this_1.willAddChild_hz2iwc_k$(element);
        if (!(this.$willRemove_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('overlay writer produced more than one element, when only one is allowed.');
        animateIn(element, this.$transition_1.forward_1);
        this.$willRemove_1._v = element;
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.$$delegate_0__1.get_underlyingNativeElement_vngz33_k$();
      }
      get_children_4cwbp4_k$() {
        return this.$$delegate_0__1.get_children_4cwbp4_k$();
      }
      addChild_51cm2s_k$(index, element) {
        this.$$delegate_0__1.addChild_51cm2s_k$(index, element);
      }
      addChild_2qpft2_k$(element) {
        this.$$delegate_0__1.addChild_2qpft2_k$(element);
      }
      removeChild_mjbjbk_k$(index) {
        this.$$delegate_0__1.removeChild_mjbjbk_k$(index);
      }
      removeChild_kofmvd_k$(element) {
        this.$$delegate_0__1.removeChild_kofmvd_k$(element);
      }
      clearChildren_eufjq4_k$() {
        this.$$delegate_0__1.clearChildren_eufjq4_k$();
      }
      get_spacingForChildCornerRadii_uorqcm_k$() {
        return this.$$delegate_0__1.get_spacingForChildCornerRadii_uorqcm_k$();
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      get_parent_hy4reb_k$() {
        return this.$$delegate_0__1.get_parent_hy4reb_k$();
      }
      onStartup_vrxh3i_k$() {
        this.$$delegate_0__1.onStartup_vrxh3i_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.$$delegate_0__1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.$$delegate_0__1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.$$delegate_0__1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.$$delegate_0__1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.$$delegate_0__1.get_visible_8zfvk9_k$();
      }
      set_paddingByEdge_53g79y_k$(_set____db54di) {
        this.$$delegate_0__1.set_paddingByEdge_53g79y_k$(_set____db54di);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.$$delegate_0__1.get_paddingByEdge_29dw58_k$();
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.$$delegate_0__1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.$$delegate_0__1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.$$delegate_0__1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.$$delegate_0__1.get_themeAndBack_k3yag2_k$();
      }
      get_dragData_pas5on_k$() {
        return this.$$delegate_0__1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.$$delegate_0__1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.$$delegate_0__1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.$$delegate_0__1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.$$delegate_0__1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.$$delegate_0__1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.$$delegate_0__1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.$$delegate_0__1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.$$delegate_0__1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.$$delegate_0__1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ContainerElement()]);
    overlay$1Class = $;
  }
  return overlay$1Class;
}
var overlay$2Class;
function overlay$2() {
  if (overlay$2Class === VOID) {
    class $ {
      constructor($transition, $this, $willRemove) {
        this.$transition_1 = $transition;
        this.$this_1 = $this;
        this.$willRemove_1 = $willRemove;
        this.$$delegate_0__1 = $this;
      }
      willAddChild_hz2iwc_k$(element) {
        this.$this_1.willAddChild_hz2iwc_k$(element);
        if (!(this.$willRemove_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('overlay writer produced more than one element, when only one is allowed.');
        animateIn(element, this.$transition_1.forward_1);
        this.$willRemove_1._v = element;
      }
      get_underlyingNativeElement_vngz33_k$() {
        return this.$$delegate_0__1.get_underlyingNativeElement_vngz33_k$();
      }
      get_children_4cwbp4_k$() {
        return this.$$delegate_0__1.get_children_4cwbp4_k$();
      }
      addChild_51cm2s_k$(index, element) {
        this.$$delegate_0__1.addChild_51cm2s_k$(index, element);
      }
      addChild_2qpft2_k$(element) {
        this.$$delegate_0__1.addChild_2qpft2_k$(element);
      }
      removeChild_mjbjbk_k$(index) {
        this.$$delegate_0__1.removeChild_mjbjbk_k$(index);
      }
      removeChild_kofmvd_k$(element) {
        this.$$delegate_0__1.removeChild_kofmvd_k$(element);
      }
      clearChildren_eufjq4_k$() {
        this.$$delegate_0__1.clearChildren_eufjq4_k$();
      }
      get_spacingForChildCornerRadii_uorqcm_k$() {
        return this.$$delegate_0__1.get_spacingForChildCornerRadii_uorqcm_k$();
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      get_parent_hy4reb_k$() {
        return this.$$delegate_0__1.get_parent_hy4reb_k$();
      }
      onStartup_vrxh3i_k$() {
        this.$$delegate_0__1.onStartup_vrxh3i_k$();
      }
      onShutdown_5jzxq3_k$() {
        this.$$delegate_0__1.onShutdown_5jzxq3_k$();
      }
      set_opacity_ecw914_k$(_set____db54di) {
        this.$$delegate_0__1.set_opacity_ecw914_k$(_set____db54di);
      }
      set_shown_mavbz5_k$(_set____db54di) {
        this.$$delegate_0__1.set_shown_mavbz5_k$(_set____db54di);
      }
      get_shown_iyiju0_k$() {
        return this.$$delegate_0__1.get_shown_iyiju0_k$();
      }
      get_visible_8zfvk9_k$() {
        return this.$$delegate_0__1.get_visible_8zfvk9_k$();
      }
      set_paddingByEdge_53g79y_k$(_set____db54di) {
        this.$$delegate_0__1.set_paddingByEdge_53g79y_k$(_set____db54di);
      }
      get_paddingByEdge_29dw58_k$() {
        return this.$$delegate_0__1.get_paddingByEdge_29dw58_k$();
      }
      set_safeAreaPadding_bpzgd4_k$(_set____db54di) {
        this.$$delegate_0__1.set_safeAreaPadding_bpzgd4_k$(_set____db54di);
      }
      set_themeChoice_py59um_k$(_set____db54di) {
        this.$$delegate_0__1.set_themeChoice_py59um_k$(_set____db54di);
      }
      get_themeChoice_22tyn3_k$() {
        return this.$$delegate_0__1.get_themeChoice_22tyn3_k$();
      }
      get_themeAndBack_k3yag2_k$() {
        return this.$$delegate_0__1.get_themeAndBack_k3yag2_k$();
      }
      get_dragData_pas5on_k$() {
        return this.$$delegate_0__1.get_dragData_pas5on_k$();
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.$$delegate_0__1.get_dropTargetDelegate_fbdv1u_k$();
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        this.$$delegate_0__1.scrollIntoView_zcj1gb_k$(horizontal, vertical, animate);
      }
      set_debugName_wihv62_k$(_set____db54di) {
        this.$$delegate_0__1.set_debugName_wihv62_k$(_set____db54di);
      }
      get_debugName_58dolx_k$() {
        return this.$$delegate_0__1.get_debugName_58dolx_k$();
      }
      set_describedBy_4bf3cf_k$(_set____db54di) {
        this.$$delegate_0__1.set_describedBy_4bf3cf_k$(_set____db54di);
      }
      get_driverValue_yh5neo_k$() {
        return this.$$delegate_0__1.get_driverValue_yh5neo_k$();
      }
      get_driverActions_8jqr2k_k$() {
        return this.$$delegate_0__1.get_driverActions_8jqr2k_k$();
      }
      driverDisplay_abwxi1_k$(options) {
        return this.$$delegate_0__1.driverDisplay_abwxi1_k$(options);
      }
      toString() {
        return this.$$delegate_0__1.toString();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ContainerElement()]);
    overlay$2Class = $;
  }
  return overlay$2Class;
}
//region block: exports
export {
  overlay as overlayt2e94k47ee8y,
};
//endregion

//# sourceMappingURL=ViewContextExtensions.commonHtml.mjs.map
